import { useState, useEffect } from "react";
import axios from "axios";
import { FaTrash } from "react-icons/fa"; // Import bin icon
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    let [key, value] = cookie.split("=");
    if (key === name) return decodeURIComponent(value);
  }
  return null;
}

const Module = () => {
  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [showNewForm, setShowNewForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState({});
  const [title, setTitle] = useState("");
  const [tagline, setTagline] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [dataUpdateThrough, setDataUpdateThrough] = useState("");
  const [url, setUrl] = useState("");
  const [category, setCategory] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setfailMessage] = useState("");
  const [organizations, setOrganization] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [moduleToDelete, setModuleToDelete] = useState(null);
  const [confirmModuleName, setConfirmModuleName] = useState(""); // Store module name input
  const [adminPassword, setAdminPassword] = useState("");
  const [defaultModules, setDefaultModules] = useState([]);
  const [selectedDefaultModule, setSelectedDefaultModule] = useState({});
  const [moduleSelectMessage, setModuleSelectMessage] = useState(null);
  const ADMIN_PASSWORD = "abc";

  const navigate = useNavigate();
  const [token, setToken] = useState(getCookie("accessToken"))

  useEffect(() => {

    setToken(getCookie("accessToken"))
    if (!token) {
      navigate("/"); // Redirect to home page

    }
    axios
      .get("https://onehum-backend.acuitas360.com/organization", {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      .then((response) => {
        setOrganization(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });

    axios
      .get("https://onehum-backend.acuitas360.com/defaultModules", {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      .then((response) => {
        setDefaultModules(response.data);


      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });


    setSelectedOrganization(organizations.find(org => org.id == selectedOrganization.id));
  }, [successMessage, showDeletePopup, showDeletePopup]);



  const handleDeleteClick = (module) => {
    setModuleToDelete(module);
    setConfirmModuleName(""); // Reset input field
    setAdminPassword(""); // Reset input field
    setShowDeletePopup(true);
  };

  const handleConfirmDelete = async () => {
    if (!moduleToDelete) return;

    // Check if user entered correct module name and password
    if (confirmModuleName !== moduleToDelete.title) {
      alert("Module name does not match.");
      return;
    }

    if (adminPassword !== ADMIN_PASSWORD) {
      alert("Incorrect admin password.");
      setAdminPassword(null)
      return;
    }
    setAdminPassword(null)

    try {
      await axios.delete(`https://onehum-backend.acuitas360.com/module/${moduleToDelete.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      setSuccessMessage("Module Deleted!");
      setShowDeletePopup(false);
      setModuleToDelete(null);
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (error) {
      console.error("Error removing module:", error);
      setfailMessage(error.AxiosError);
      setShowDeletePopup(false);
      setModuleToDelete(null);

      setTimeout(() => {
        setfailMessage("");
      }, 3000);
    }
  };

  const handleNewSubmit = async (e) => {
    e.preventDefault();
    if (!selectedDefaultModule.id) {
      setModuleSelectMessage("Please select base module!")
      return
    }

    const newModule = {
      name: selectedDefaultModule.name,
      title,
      tagline,
      category,
      logo: logoUrl,
      dataUpdateThrough: dataUpdateThrough || new Date().toISOString().split("T")[0],
      url,
      organizationId: selectedOrganization.id
    };    // console.log(selectedOrganization)

    try {
      const response = await axios.post("https://onehum-backend.acuitas360.com/module", newModule, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response.status === 201) {
        setSuccessMessage("New module created successfully!");
        setTagline("");
        setLogoUrl("");
        setUrl("");
        setSelectedDefaultModule({})
        setTitle("")
        setTagline("")
        setCategory("")
        setDataUpdateThrough("")
        setTimeout(() => {
          setShowNewForm(false);
          setSuccessMessage("");
          setSelectedModule(null);
        }, 2000);
      }
    } catch (error) {
      console.error(error);
      setfailMessage("New module not created Created!");
      setShowDeletePopup(false);
      setModuleToDelete(null);

      setTimeout(() => {
        setfailMessage("");
      }, 3000);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    if (adminPassword !== ADMIN_PASSWORD) {
      alert("Incorrect admin password.");
      setAdminPassword(null)
      return;
    }
    setAdminPassword(null)

    try {
      const response = await axios.patch(`https://onehum-backend.acuitas360.com/module/${showEditForm.id}`, showEditForm, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setSuccessMessage("Module updated successfully!");
        setTimeout(() => {
          setShowEditForm(false);
          setSuccessMessage("");
          setSelectedModule(null);
        }, 2000);
      }
    } catch (error) {
      console.error(error);
      setfailMessage("Failed to update module!");
      setShowDeletePopup(false);
      setModuleToDelete(null);

      setTimeout(() => {
        setfailMessage("");
      }, 3000);
    }
    setShowEditForm(false);
  };

  return (
    <div className="p-4 bg-gray-100 rounded">
      {/* Select Organization Dropdown */}
      <label className="block mb-2 text-lg font-medium">Select Organization:</label>
      <select
        className="w-full p-2 border rounded mb-4"
        onChange={(e) => {
          if (true) {  // Prevent changing the value if azk is true
            const organization = organizations.find((org) => org.id === parseInt(e.target.value));
            setSelectedOrganization(organization);
            setSelectedModule(null);  // Reset module selection when organization changes
          }
        }}
        value={selectedOrganization ? selectedOrganization.id : ""}
        disabled={showNewForm || showEditForm.id}
      >
        <option value="">-- Select --</option>
        {organizations.map((organization) => (
          <option key={organization.id} value={organization.id}>
            {organization.name}
          </option>
        ))}
      </select>



      {/* Success Message */}
      {successMessage && (
        <div className="text-green-600 font-semibold mt-4 text-center bg-green-200 p-2 rounded fixed w-full top-0 left-0">
          {successMessage}
        </div>
      )}

      {/* failed Message */}
      {failMessage && (
        <div className="text-red-600 font-semibold mt-4 text-center bg-red-200 p-2 rounded fixed w-full top-10 left-0">
          {failMessage}
        </div>
      )}

      {/* New/Edit Module Form Buttons */}
      <div className="flex justify-start mb-4">
        {/* New Button */}
        <button
          onClick={() => { setShowEditForm(false); setShowNewForm(true); }}
          disabled={!selectedOrganization}
          className={`px-4 py-2 ${selectedOrganization ? "bg-blue-500" : "bg-gray-400"} text-white rounded`}
        >
          New Module
        </button>


      </div>


      {/* New Module Form */}
      {showNewForm && !showEditForm.id && (
        <form onSubmit={handleNewSubmit} className="mt-4 p-4 bg-white shadow-md rounded  overflow-y-auto">
          <h3 className="text-lg font-medium mb-2">Add New Module</h3>

          {/* Organization Dropdown (Pre-filled with selected organization) */}
          <label className="block mb-2">Organization</label>
          <input
            type="text"
            value={selectedOrganization.name}
            className="w-full p-2 border rounded mb-4 cursor-not-allowed focus:outline-none focus:border-none text-gray-400"
            readOnly
            style={{ pointerEvents: 'none', borderColor: '#ccc' }}
          />


          <label className="block mb-2">Select Base Module</label>
          <select
            className="w-full p-2 border rounded mb-4"
            onChange={(e) => {

              const defaultmodule = defaultModules.find((org) => org.id === parseInt(e.target.value));
              setSelectedDefaultModule(defaultmodule);
              setSelectedModule(null);  // Reset module selection when organization changes
              setTitle(defaultmodule.title)
              setTagline(defaultmodule.tagline)
              setLogoUrl(defaultmodule.logo)
              setModuleSelectMessage(null)
              setCategory(defaultmodule.category)

            }}
            value={selectedDefaultModule ? selectedDefaultModule.id : ""}
          >

            {!selectedDefaultModule.id && <option value="">-- Select --</option>}

            {defaultModules.map((organization) => (
              <option key={organization.id} value={organization.id}>
                {organization.name}
              </option>
            ))}
          </select>



          <label className="block mb-2">Name</label>
          <input
            type="text"
            value={selectedDefaultModule.name}
            className="w-full p-2 border rounded mb-4 cursor-not-allowed focus:outline-none focus:border-none text-gray-400"
            readOnly
            style={{ pointerEvents: 'none', borderColor: '#ccc' }}
          />



          {/* Title */}
          <label className="block mb-2">Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full p-2 border rounded mb-4 text-black"
            required
          />

          {/* Tagline */}
          <label className="block mb-2">Tagline</label>
          <input
            type="text"
            value={tagline}
            onChange={(e) => setTagline(e.target.value)}
            className="w-full p-2 border rounded mb-4 text-black"
            required
          />

          <label className="block mb-2">Category</label>
          <input
            type="text"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="w-full p-2 border rounded mb-4 text-black"
            required
          />


          {/* Logo URL */}
          <label className="block mb-2">Logo URL</label>
          <input
            type="text"
            value={logoUrl}
            onChange={(e) => setLogoUrl(e.target.value)}
            className="w-full p-2 border rounded mb-4 text-black"
            required
          />

          {/* Data Update Through (Date) */}
          <label className="block mb-2">Data Update Through (Date)</label>
          <input
            type="date"
            value={dataUpdateThrough}
            onChange={(e) => setDataUpdateThrough(e.target.value)}
            className="w-full p-2 border rounded mb-4 text-black"
            
          />

          {/* URL */}
          <label className="block mb-2">URL</label>
          <input
            type="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="w-full p-2 border rounded mb-4 text-black"
            required
          />

          <label className="block mb-2 text-red-500">{moduleSelectMessage}</label>

          {/* Form Buttons */}
          <div className="flex justify-between">
            <button type="submit" className="px-4 py-2 bg-green-500 text-white rounded">
              Submit
            </button>
            <button
              type="button"
              onClick={() => {
                setShowNewForm(false);
                setSelectedModule(null);
              }}
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
            >
              Back
            </button>
          </div>
        </form>
      )}



      {/* Edit Module Form */}
      {showEditForm.id && (
        <form onSubmit={handleEditSubmit} className="mt-4 p-4 bg-white shadow-md rounded  overflow-y-auto" id="editForm">
          <h3 className="text-lg font-medium mb-2">Edit Module</h3>

          {/* Organization (Fixed value, non-editable) */}
          <label className="block mb-2">Organization</label>
          <input
            type="text"
            value={selectedOrganization ? selectedOrganization.name : ""}
            className="w-full p-2 border rounded mb-4 text-gray-500"
            disabled
          />



          <label className="block mb-2">Name</label>
          <input
            type="text"
            value={showEditForm.name}
            className="w-full p-2 border rounded mb-4 text-gray-500"
            disabled
          />

          {/* Title (Fixed value, non-editable) */}
          <label className="block mb-2">Title</label>
          <input
            type="text"
            value={showEditForm.title}
            onChange={(e) => setShowEditForm({ ...showEditForm, title: e.target.value })}
            className="w-full p-2 border rounded mb-4 text-black"
            required

          />

          {/* Tagline */}
          <label className="block mb-2">Tagline</label>
          <input
            type="text"
            value={showEditForm.tagline}
            onChange={(e) => setShowEditForm({ ...showEditForm, tagline: e.target.value })}
            className="w-full p-2 border rounded mb-4 text-black"
            required
          />

          <label className="block mb-2">Category</label>
          <input
            type="text"
            value={showEditForm.category}
            onChange={(e) => setShowEditForm({ ...showEditForm, category: e.target.value })}
            className="w-full p-2 border rounded mb-4 text-black"
            required
          />

          {/* Logo URL */}
          <label className="block mb-2">Logo URL</label>
          <input
            type="text"
            value={showEditForm.logo}
            onChange={(e) => setShowEditForm({ ...showEditForm, logo: e.target.value })}
            className="w-full p-2 border rounded mb-4 text-black"
            required
          />

          {/* Data Update Through */}
          <label className="block mb-2">Data Update Through</label>
          <input
            type="date"
            value={showEditForm.dataUpdateThrough}
            onChange={(e) => setShowEditForm({ ...showEditForm, dataUpdateThrough: e.target.value })}
            className="w-full p-2 border rounded mb-4 text-black"
            
          />

          {/* URL */}
          <label className="block mb-2">URL</label>
          <input
            type="url"
            value={showEditForm.url}
            onChange={(e) => setShowEditForm({ ...showEditForm, url: e.target.value })}
            className="w-full p-2 border rounded mb-4 text-black"
            required
          />

          <label className="block mb-2">Admin Password</label>
          <input
            type="password"
            placeholder="Enter admin password"
            value={adminPassword}
            onChange={(e) => setAdminPassword(e.target.value)}
            className="w-full p-2 border rounded mb-4 text-black"
            required
          />

          {/* Form Buttons */}
          <div className="flex justify-between">
            <button type="submit" className="px-4 py-2 bg-yellow-500 text-white rounded">
              Save Changes
            </button>
            <button
              type="button"
              onClick={() => {
                setShowEditForm(false);
                setSelectedModule(null);
              }}
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
            >
              Back
            </button>
          </div>
        </form>
      )}



      {/* Module Info Display */}

      {selectedOrganization && selectedOrganization.module.length > 0 && (
        <div className="bg-white p-4 rounded shadow-md mt-4">
          <h3 className="text-lg font-semibold mb-4 text-center">Modules in {selectedOrganization.name}</h3>
          <ul className="divide-y divide-gray-300">
            {selectedOrganization.module.map((user, index) => (
              <li key={user.id} className="flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 rounded-md transition">
                <div className="flex items-center gap-3 w-full">

                  {/* Serial Number */}
                  <span className="font-semibold text-gray-700 w-6">{index + 1}.</span>

                  {/* User Logo */}
                  <img src={user.logo} alt={user.title} className="mt-2 w-24 h-16" />

                  {/* User Details */}
                  <div className="flex flex-col w-64 px-3">
                    <p className="font-medium text-lg mb-2">
                      <strong>{user.title}</strong>
                    </p>
                    <p className="text-lg text-gray-600">{user.tagline}</p>
                  </div>

                  {/* Category & Data Update */}
                  <div className="flex flex-col w-full px-3">
                    <div className="flex mb-2">
                      <p>Category: <strong className="font-medium mr-5">{user.category}</strong></p>
                      <p>Data Update Through: <strong className="font-medium">{user.dataUpdateThrough}</strong></p>
                    </div>

                    {/* URL Section */}
                    <p>
                      URL: <strong className="font-medium"></strong>
                      <div className="break-words overflow-hidden">
                        <a
                          href={user.url}
                          className="text-blue-500 break-all block"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {user.url}
                        </a>
                      </div>
                    </p>
                  </div>

                </div>

                {/* Actions (Edit & Delete) */}
                <div className="flex">
                  <a href="#editForm">
                    <FaEdit className="text-blue-500 cursor-pointer text-xl mx-3" onClick={() => setShowEditForm(user)} />
                  </a>
                  <FaTrash className="text-red-500 cursor-pointer text-xl mx-3" onClick={() => handleDeleteClick(user)} />
                </div>

              </li>
            ))}

          </ul>
        </div>
      )}

      {showDeletePopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-md text-center">
            <p className="text-lg font-base mb-4">Enter module name <span className="font-medium">"{moduleToDelete.title}" </span> again and admin password to delete:</p>

            <input
              type="text"
              placeholder="Enter module name"
              onPaste={(e) => e.preventDefault()}
              value={confirmModuleName}
              onChange={(e) => setConfirmModuleName(e.target.value)}
              className="w-full p-2 border rounded mb-4 text-black"
              required
            />

            <input
              type="password"
              placeholder="Enter admin password"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              className="w-full p-2 border rounded mb-4 text-black"
              required
            />

            <div className="flex justify-center gap-4">
              <button className="p-2 bg-gray-500 text-white rounded hover:bg-gray-600" onClick={() => setShowDeletePopup(false)}>
                Cancel
              </button>
              <button className="p-2 bg-red-500 text-white rounded hover:bg-red-600" onClick={handleConfirmDelete}>
                Confirm Delete
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Module;
